import type {AutoLayoutJob} from "@buildwithflux/models";
import {diff} from "deep-diff";

/**
 * Checks if a job change is trivial (only selectedIterationHash changed)
 * @param previousJob - The previous job state
 * @param currentJob - The current job state
 * @returns true if only selectedIterationHash changed, false otherwise
 */
export function isTrivialJobChange(previousJob: AutoLayoutJob | undefined, currentJob: AutoLayoutJob): boolean {
    if (!previousJob) {
        return false;
    }

    const diffs = diff(previousJob, currentJob) || [];

    const [firstDiff, ...restDiffs] = diffs;
    if (!firstDiff || restDiffs.length > 0) {
        return false;
    }

    const onlySelectedIterationHashChanged =
        firstDiff.kind === "E" &&
        firstDiff.path &&
        firstDiff.path.length === 1 &&
        firstDiff.path[0] === "selectedIterationHash";

    if (onlySelectedIterationHashChanged) {
        return true;
    }

    return false;
}
